import { AVATAR_QUALITY_LIST } from "@/lib/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import type { AvatarQuality } from "@/types/TAvatarSettings";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function VideoQualitySelect() {
  const { t } = useTranslation();
  const avatarQuality = SettingsStore(state => state.avatarQuality);
  const setAvatarQuality = SettingsStore(state => state.setAvatarQuality);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <Label htmlFor="video-quality">{t("settings.videoQuality")}</Label>
      <Select
        value={avatarQuality}
        onValueChange={(value) => setAvatarQuality(value as AvatarQuality)}
        disabled={isLoading}
      >
        <SelectTrigger id="video-quality" className="w-full">
          <SelectValue placeholder="Select Video Quality" />
        </SelectTrigger>
        <SelectContent>
          {AVATAR_QUALITY_LIST.map((quality) => (
            <SelectItem
              key={quality.key}
              value={quality.value}
            >
              {t(quality.label)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </ControlWrapper>
  );
}